export enum HouseContentsInsuranceType {
  HOUSE_CONTENTS_STANDARD = "houseContentsStandard",
  HOUSE_CONTENTS_SUPER = "houseContentsSuper",
}
